module.exports = __webpack_public_path__ + "img/edp-logo.58a37a99.svg";